import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const FacilityDashboard = lazyPage(() => import('@/pages/facility/Dashboard'));
const Buildings = lazyPage(() => import('@/pages/facility/Buildings'));
const Classrooms = lazyPage(() => import('@/pages/facility/Classrooms'));
const Labs = lazyPage(() => import('@/pages/facility/Labs'));
const Auditorium = lazyPage(() => import('@/pages/facility/Auditorium'));
const Playground = lazyPage(() => import('@/pages/facility/Playground'));
const MeetingRooms = lazyPage(() => import('@/pages/facility/MeetingRooms'));
const FacilityBookings = lazyPage(() => import('@/pages/facility/Bookings'));
const FacilityMaintenance = lazyPage(() => import('@/pages/facility/Maintenance'));
const FacilityCleaning = lazyPage(() => import('@/pages/facility/Cleaning'));
const FacilitySecurity = lazyPage(() => import('@/pages/facility/Security'));
const CampusMaps = lazyPage(() => import('@/pages/facility/CampusMaps'));
const FacilityReports = lazyPage(() => import('@/pages/facility/Reports'));

export const facilityRoutes: AppRoute[] = [
  {
    path: 'facility',
    title: 'Facility & Campus',
    children: [
      { path: '', title: 'Facility & Campus', component: ModuleMenu },
      { path: 'dashboard', title: 'Dashboard', component: FacilityDashboard },
      { path: 'buildings', title: 'Buildings', component: Buildings },
      { path: 'classrooms', title: 'Classrooms', component: Classrooms },
      { path: 'labs', title: 'Labs', component: Labs },
      { path: 'auditorium', title: 'Auditorium', component: Auditorium },
      { path: 'playground', title: 'Playground', component: Playground },
      { path: 'meeting-rooms', title: 'Meeting Rooms', component: MeetingRooms },
      { path: 'bookings', title: 'Facility Booking', component: FacilityBookings },
      { path: 'maintenance', title: 'Maintenance', component: FacilityMaintenance },
      { path: 'cleaning', title: 'Cleaning', component: FacilityCleaning },
      { path: 'security', title: 'Security', component: FacilitySecurity },
      { path: 'maps', title: 'Campus Maps', component: CampusMaps },
      { path: 'reports', title: 'Facility Reports', component: FacilityReports },
    ],
  },
];
